import { format } from "date-fns";
import { END_POINT } from "../../utils/End-points";
import { Helper } from "../../utils/Helpers";

const { roundOff } = new Helper();

const esc = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const row = (label, value) =>
  value === null || value === undefined || value === ""
    ? ""
    : `<tr><td class="label">${esc(label)}</td><td class="value">${esc(value)}</td></tr>`;

const buildReceiptHtml = (data) => {
  const hotel = data.hotel || {};
  const refundDate = data.refund_date
    ? format(new Date(data.refund_date), "dd-MM-yyyy HH:mm")
    : "-";

  return `
    <div class="receipt">
      <div class="center bold hotel">${esc(hotel.hotel_name || "Hotel")}</div>
      ${hotel.hotel_address ? `<div class="center muted">${esc(hotel.hotel_address)}</div>` : ""}
      ${hotel.hotel_gstin_number ? `<div class="center muted">GSTIN: ${esc(hotel.hotel_gstin_number)}</div>` : ""}
      <div class="divider"></div>
      <div class="center bold title">REFUND RECEIPT</div>
      <table>
        ${row("Refund No", data.refund_number)}
        ${row("Date", refundDate)}
        ${row("Guest Name", data.guest_name)}
        ${row("Mobile", data.guest_mobile)}
        ${row("Booking ID", data.booking_ref_id || data.booking_id)}
      </table>
      <div class="divider"></div>
      <table>
        ${row("Invoice No", data.invoice_number)}
        ${row("Refund Method", data.refund_payment_type)}
        ${row("Reason", data.refund_reason ? data.refund_reason.replace(/_/g, " ") : "")}
        ${row("Remarks", data.refund_remarks)}
      </table>
      <div class="divider"></div>
      <div class="amount-row">
        <span>Refund Amount</span>
        <span>${esc(roundOff(data.refund_amount))}</span>
      </div>
    </div>
  `;
};

const PRINT_STYLES = `
  body { font-family: Calibri, sans-serif; padding: 20px; font-size: 13px; margin: 0; }
  .receipt { max-width: 360px; margin: 0 auto; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 4px 0; vertical-align: top; }
  .label { color: #666; width: 42%; }
  .value { font-weight: 500; }
  .center { text-align: center; }
  .bold { font-weight: 700; }
  .muted { color: #666; font-size: 11px; }
  .hotel { font-size: 17px; margin-bottom: 2px; }
  .title { font-size: 13px; letter-spacing: 0.5px; margin: 6px 0; }
  .divider { border-top: 1px dashed #ccc; margin: 10px 0; }
  .amount-row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 16px; font-weight: 700; }
`;

export const printRefundReceipt = async (api, refundKey, onError) => {
  try {
    const res = await api.get(END_POINT.REFUND.RECEIPT(refundKey));
    const data = res?.data?.data;
    if (!data) {
      onError?.("Refund receipt not found");
      return;
    }

    const printWindow = window.open("", "_blank", "width=420,height=640");
    if (!printWindow) {
      onError?.("Allow pop-ups to print the refund receipt");
      return;
    }

    printWindow.document.write(
      `<html><head><title>Refund Receipt ${esc(data.refund_number || "")}</title>` +
        `<style>${PRINT_STYLES}</style></head><body>${buildReceiptHtml(data)}</body></html>`
    );
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  } catch (err) {
    onError?.(err?.response?.data?.msg || "Failed to print refund receipt");
  }
};

export default printRefundReceipt;
